import { Injectable } from '@angular/core';
import { CcfacRange, Ccenter } from '../models';
import { Observable, Subscription } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CcenterService {
  private ccfacRanges$: Observable<CcfacRange[]> = null;
  private ccCenter$: Observable<Ccenter[]> = null;
  private readonly api = `api/main`;

  constructor(private readonly httpClient: HttpClient) {}

  getCcfacRanges() {
    if (!this.ccfacRanges$) {
      this.ccfacRanges$ = this.httpClient.get<CcfacRange[]>(`${this.api}/ccfacranges`).pipe(shareReplay(1));
    }
    return this.ccfacRanges$;
    }


  getCcenter(range: string = null, descFilter: string = null, sortByNumber: boolean = false) {
    let params = new HttpParams();
    // TypeScript sends "null" as a string if param is null
    if (range != null) {
      params = params.set('range', range.toString());
    }
    if (descFilter != null) {
      params = params.set('descFilter', descFilter.toString());
    }
    if (sortByNumber != null) {
      params = params.set('sortByNumber', sortByNumber.toString());
    }

    this.ccCenter$ = this.httpClient
      .get<Ccenter[]>(`${this.api}/ccenter`, {
        params: params,
      })
      .pipe(shareReplay(1));

    return this.ccCenter$;
    }
}
